import { Injectable } from '@angular/core';

declare var $: any;

@Injectable()
export class VMsg_en_US {
static load() {

/*
 * Translated default messages for the jQuery validation plugin.
 * Locale: EN (English)
 */
$.extend( $.validator.messages, {
	required: "This field is required.",
	remote: "Please fix this field.",
	email: "Please enter a valid email address.",
	url: "Please enter a valid URL.",
	date: "Please enter a valid date.",
	dateISO: "Please enter a valid date (ISO).",
	number: "Please enter a valid number.",
	digits: "Please enter only digits.",
	creditcard: "Please enter a valid credit card number.",
	equalTo: "Please enter the same value again.",
	extension: "Please enter a value with a valid extension.",
	maxlength: $.validator.format( "Please enter no more than {0} characters." ),
	minlength: $.validator.format( "Please enter at least {0} characters." ),
	rangelength: $.validator.format( "Please enter a value between {0} and {1} characters long." ),
	range: $.validator.format( "Please enter a value between {0} and {1}." ),
	max: $.validator.format( "Please enter a value less than or equal to {0}." ),
	min: $.validator.format( "Please enter a value greater than or equal to {0}." ),
	step: $.validator.format( "Please enter a multiple of {0}." ),
	accept: "Please enter a value with a valid extension.",
	alphanumeric: "Please enter letters, numbers, and underscores only.",
	integer: "Please a positive or negative non-decimal number.",
	ipv4: "Please enter a valid IP v4 address.",
	ipv6: "Please enter a valid IP v6 address.",
	lettersonly: "Please enter letters only.",
	letterswithbasicpunc: "Please enter letters or punctuation only.",
	notEqualTo: "Please enter a different value, values must not be the same.",
	nowhitespace: "Please don't enter white space",
	pattern: $.validator.format( "Invalid format ({0})." ),
	time: "Please enter a valid time, between 00:00 and 23:59.",
	url2: "Please enter a valid URL.",
	minbytelength: $.validator.format( "Please enter at least {0} bytes of characters." ),
	maxByteLength: $.validator.format( "Please enter no more than {0} bytes of characters." ),
	rangeByteLength: $.validator.format( "Please enter a value between {0} and {1} bytes of characters." ),
	halfWidth: "Please enter half-width characters.",
	fullWidth: "Please enter full-width characters.",
	kanji: "Please enter kanji characters.",
	kana: "Please enter kana characters.",
	hiragana: "Please enter hiragana characters.",
	katakana: "Please enter katakana characters.",
	halfKatakana: "Please enter half katakana characters.",
	fullKatakana: "Please enter full katakana characters.",
	date_yyyyMMdd: "Please enter a valid date(yyyyMMdd).",
	date_yyyy_MM_dd: "Please enter a valid date(yyyy/MM/dd).",
	date_yyyy_MM: "Please enter a valid date(yyyy/MM).",
	date_yyyyMM: "Please enter a valid date(yyyyMM).",
	date_MM_dd: "Please enter a valid date(MM/dd).",
	date_MMdd: "Please enter a valid date(MMdd).",
	time_HH_mm: "Please enter a valid time(HH:mm).",
	time_HH_mm_ss: "Please enter a valid time(HH:mm:ss).",
	time_HHmmss: "Please enter a valid time(HHmmss).",
	phoneJP: "Please specify a valid phone number.",
	mobileJP: "Please specify a valid mobile number.",
	numberLessThen: "Please enter a lesser number.",
	numberLessEqualTo: "Please enter a same number or less.",
	dateLessThen: "Please specify an earlier time.",
	dateLessEqualTo: "Please specify a same or earlier time.",
	pwd: "Either number, letter or mark[@#$%] is rquired."
} );
}
}


// WEBPACK FOOTER //
// C:/wxj/LicAuth/05開発/LicAuth.angularjs/src/app/resources/validate_en-US.ts